import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import rootReducer from 'reducers';
import rootSaga from 'sagas';
import createRavenMiddleware from 'raven-for-redux';

const RAVEN_OPTIONS = {
  stateTransformer: state => {
    const newState = { ...state };
    delete newState.entities;
    delete newState.app;

    return newState;
  }
};

export default function configureStore(context) {
  const sagaMiddleware = createSagaMiddleware({
    context
  });

  let finalCreateStore;

  if (process.env.NODE_ENV === 'development') {
    const logger = createLogger();
    finalCreateStore = compose(
      applyMiddleware(sagaMiddleware, logger),
      global.window && global.window.devToolsExtension ? global.window.devToolsExtension() : f => f
    )(createStore);
  } else {
    const middlewares = [sagaMiddleware];
    if (global.window && global.window.Raven) {
      middlewares.push(createRavenMiddleware(global.window.Raven, RAVEN_OPTIONS));
    }
    finalCreateStore = applyMiddleware(...middlewares)(createStore);
  }

  return {
    store: finalCreateStore(rootReducer),
    runApp: () => sagaMiddleware.run(rootSaga)
  };
}



// WEBPACK FOOTER //
// ./src/store.js